import {
  AUDIO_BOUNDARY_REACHED,
  AUDIO_CANCEL_SUCCESS,
  AUDIO_CHANGE_RATE_SUCCESS,
  AUDIO_PAUSE_SUCCESS,
  AUDIO_PLAY,
  AUDIO_RESUME_SUCCESS,
  AUDIO_SET_VOICE_SUCCESS,
  AUDIO_STOP_SUCCESS,
  REQUEST_OFFLINE_VOICES_SUCCESS,
} from "./constants";
import { IAudioState } from "./IAudioState";
import {
  AudioActions,
  AudioBoundaryReached,
  AudioChangeRateSuccess,
  AudioSetVoiceSuccess,
  RequestOfflineVoicesSuccess,
} from "./actionTypes";

const defaultAudioState: IAudioState = {
  voices: [],
  isPlaying: false,
  isPaused: false,
  selectedVoice: '',
  rate: 0,
  isCanceled: false,
  highlightPosition: {
    startPosition: 0,
    endPosition: 0,
  },
};

export function audioReducer(state = defaultAudioState, { type, ...action }: AudioActions): IAudioState {
  switch (type) {
    case AUDIO_BOUNDARY_REACHED: {
      const { payload } = action as AudioBoundaryReached;

      return ({
        ...state,
        highlightPosition: payload,
      });
    }

    case AUDIO_CANCEL_SUCCESS:
      return ({
        ...state,
        isCanceled: true,
        isPlaying: false,
        isPaused: false,
      });

    case AUDIO_CHANGE_RATE_SUCCESS: {
      const { payload } = action as AudioChangeRateSuccess;

      return ({
        ...state,
        rate: payload,
      });
    }

    case AUDIO_PAUSE_SUCCESS:
      return ({
        ...state,
        isPlaying: false,
        isPaused: true,
        isCanceled: false,
      });

    case AUDIO_PLAY:
      return ({
        ...state,
        isPlaying: true,
        isPaused: false,
        isCanceled: false,
      });

    case AUDIO_RESUME_SUCCESS:
      return ({
        ...state,
        isPlaying: true,
        isPaused: false,
        isCanceled: false,
      });

    case AUDIO_STOP_SUCCESS:
      return ({
        ...state,
        isPlaying: false,
        isPaused: false,
        isCanceled: false,
      });

    case REQUEST_OFFLINE_VOICES_SUCCESS: {
      const { payload } = action as RequestOfflineVoicesSuccess;

      return ({
        ...state,
        voices: payload,
      });
    }

    case AUDIO_SET_VOICE_SUCCESS: {
      const { payload } = action as AudioSetVoiceSuccess;

      return ({
        ...state,
        selectedVoice: payload,
      });
    }

    default:
      return state;
  }
}
